import { useState, useRef, useEffect } from "react";
import { Link,useNavigate} from "react-router-dom";
import "./Navbar.css";
import MarketsDropdown from "./MarketsDropdown";
import MoreDropdown from "./MoreDropdown";

const Navbar = () => {
  const [isMarketsOpen,setIsMarketsOpen ] = useState(false);
  const [isMoreOpen, setIsMoreOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  
  const [isRegionOpen, setIsRegionOpen] = useState(false);
  const [selectedRegion, setSelectedRegion] = useState("Asia");

  // const [triggerMarketsTransition, setTriggerMarketsTransition] = useState(false);


   
  const regionRef = useRef(null);



  const marketsRef = useRef(null);
  const moreRef = useRef(null);
  const dropdownRef = useRef(null);
  const moreDropdownRef = useRef(null);
 const navigate = useNavigate();



  const closeMarketsDropdown = () => {
    setIsMarketsOpen(false);
  };

 

  const toggleMoreDropdown = () => {
    setIsMoreOpen(!isMoreOpen);
    setIsMarketsOpen(false);
    
  };

  const closeMoreDropdown = () => {
    setIsMoreOpen(false);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    
  };

 
 
  




  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      const clickedInsideMarkets =
        marketsRef.current?.contains(event.target) ||
        dropdownRef.current?.contains(event.target);

      const clickedInsideMore =
        moreRef.current?.contains(event.target) ||
        moreDropdownRef.current?.contains(event.target);

      if (!clickedInsideMarkets) setIsMarketsOpen(false);
      if (!clickedInsideMore) setIsMoreOpen(false);
    };

     if (isMarketsOpen || isMoreOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMarketsOpen, isMoreOpen]);

   // Handle ESC key to close dropdowns
  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === "Escape") {
        setIsMarketsOpen(false);
        setIsMoreOpen(false);
      }
    };

    document.addEventListener("keydown", handleEscKey);
    return () => {
      document.removeEventListener("keydown", handleEscKey);
    };
  }, []);




   useEffect(() => {
  function handleClickOutside(event) {
    if (regionRef.current && !regionRef.current.contains(event.target)) {
      setIsRegionOpen(false);
    }
  }

  document.addEventListener("mousedown", handleClickOutside);
  return () => document.removeEventListener("mousedown", handleClickOutside);
}, []);





  return (
    <>
      <nav className="navbar" role="navigation" aria-label="Main Navigation">
        <div className="navbar-logo" aria-label="RedBox Global"></div>

        {/* Mobile Menu Toggle */}
        {/* <button 
          className="mobile-menu-toggle" 
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
          aria-expanded={isMobileMenuOpen}
        >
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button> */}

        <ul className={`navbar-links ${isMobileMenuOpen ? 'mobile-active' : ''}`}>
          <li className="live-tv">
            <Link to="/live-tv" aria-label="Live TV">Live TV</Link>
          </li>
        

          {/* <li 
            className="markets" 
            ref={marketsRef}
          > */}

          <li
          className="markets"
          ref={marketsRef}
          onMouseEnter={() => {
          clearTimeout(window.marketsTimeout);
          setIsMarketsOpen(true);
           setIsMoreOpen(false);
      }}
         onMouseLeave={() => {
         window.marketsTimeout = setTimeout(() => {
        setIsMarketsOpen(false);
         }, 300); // 👈 smooth Bloomberg delay
  }}
>
             
            
{/* 
            <Link
               to="/markets"
              className="markets-link"
              onClick={(e) => {
             e.preventDefault(); // prevent default navigation

            if (!isMarketsOpen) {
           // if dropdown is closed, open it and navigate
            setIsMarketsOpen(true);
            setIsMoreOpen(false);
           navigate("/markets");
          } else {
           // if dropdown is open, close it
           setIsMarketsOpen(false);
         }
        }}
       >
       Markets
     </Link> */}


      {/* <Link to="/markets"
      className="markets-link"
       onClick={(e) => {
             e.preventDefault(); // prevent default navigation

            if (!isMarketsOpen) {
           // if dropdown is closed, open it and navigate
            setIsMarketsOpen(true);
            setIsMoreOpen(false);
           navigate("/markets");
          } else {
           // if dropdown is open, close it
           setIsMarketsOpen(false);
         }
        }}
       ></Link> */}

     
     <Link
      to="/markets"
     className="markets-link"
     onClick={(e) => {
     e.preventDefault();

    // open dropdown (UX like Bloomberg)
    setIsMarketsOpen(true);
    setIsMoreOpen(false);

    // 👇 delay for smooth feel
    setTimeout(() => {
      navigate("/markets", { state: { animate: true } });
       }, 150);
    }}
  >
    Markets
  </Link>
       




     <button
        onClick={() => setIsMarketsOpen(prev => !prev)} // optional arrow toggle
    aria-expanded={isMarketsOpen}
    aria-haspopup="true"
    aria-label="Markets dropdown menu"
    className="markets-dropdown-toggle"
  >
      <span className={`dropdown-arrow ${isMarketsOpen ? 'open' : ''}`}>▼</span>
  </button>
</li>
            

          <li><Link to="/economics">Economics</Link></li>
          <li><Link to="/industries">Industries</Link></li>
          <li><Link to="/tech">Tech</Link></li>
          <li><Link to="/politics">Politics</Link></li>
          <li><Link to="/businessweek">Businessweek</Link></li>
          <li><Link to="/opinion">Opinion</Link></li>
          
          <li 
            className="more" 
            ref={moreRef}
          >
            <button 
              onClick={toggleMoreDropdown}
              aria-expanded={isMoreOpen}
              aria-haspopup="true"
              aria-label="More menu"
              className="more-toggle"
            >
              More
              <span className={`dropdown-arrow ${isMoreOpen ? 'open' : ''}`}>▼</span>
            </button>
          </li>
        </ul>

      {/* <button 
         className="subscribe-btn"
         onClick={() => navigate("/subscribe")}
        >
          Subscribe
     </button> */}

        {/* ✅ REGION SELECTOR ADDED HERE */}
     {/* <div className="region-selector" ref={regionRef}>
      <button
        className="region-toggle"
        onClick={() => setIsRegionOpen(prev => !prev)}
        aria-expanded={isRegionOpen}
      >
        {selectedRegion} Edition 
        <span className={`dropdown-arrow ${isRegionOpen ? "open" : ""}`}>▼</span>
      </button>

      {isRegionOpen && (
        <div className="region-dropdown">
          {[
            "US",
            "UK",
            "Canada",
            "Latin America",
            "Europe",
            "Asia",
            "Middle East",
            "Africa",
            "Japan"
          ].map(region => (
            <div
              key={region}
              className={`region-item ${selectedRegion === region ? "active" : ""}`}
              onClick={() => {
                setSelectedRegion(region);
                setIsRegionOpen(false);
              }}
            >
              {region}
              {selectedRegion === region && <span className="check">✓</span>}
            </div>
          ))}
        </div>
      )}
    </div> */}

      </nav>

      

      {/* Markets Dropdown */}

   

      {isMarketsOpen && (
      <MarketsDropdown 
        isOpen={isMarketsOpen} 
        onClose={closeMarketsDropdown}  
         
        dropdownRef={dropdownRef}
        
      />
      )}
       
      
      {/* More Dropdown */}
       {isMoreOpen && (
      <MoreDropdown 
        isOpen={isMoreOpen} 
        onClose={closeMoreDropdown} 
        dropdownRef={moreDropdownRef}
      />
      )}
       
    </>
  );
};

export default Navbar;